import { Cancel, CheckCircle, Close } from "@mui/icons-material";
import { Snackbar, Alert, IconButton } from "@mui/material";
import { useEffect, useState } from "react";
import { COLORS } from "../../../utils/colors";
const RenderSnackBar = ({ showToast, toastConfig, onClose }) => {
  const [show, setShow] = useState(showToast);

  useEffect(() => {
    setShow(showToast);
  }, [showToast]);
  return (
    <Snackbar
      open={show}
      autoHideDuration={toastConfig?.duration || 2000}
      onClose={() => onClose()}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
    >
      <Alert
        severity={toastConfig.type}
        variant="standard"
        icon={
          toastConfig.type === "success" ? (
            <CheckCircle sx={{ color: COLORS.success }} />
          ) : (
            <Cancel sx={{ color: COLORS.error }} />
          )
        }
      >
        {toastConfig.message}
        <>
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={() => setShow(false)}
            sx={{ ml: 1 }}
          >
            <Close fontSize="small" />
          </IconButton>
        </>
      </Alert>
    </Snackbar>
  );
};
export default RenderSnackBar;
